(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemListController', ServiceItemListController);

    ServiceItemListController.$inject = ['$scope', '$state', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate'];

    function ServiceItemListController($scope, $state, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate) {
        var vm = this;
        //
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            vm.serviceItems = ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('RESERVE').query();
            //vm.page = page;
            //vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }
    }
})();
